<template>
    <div>
        <div>
            <div class="form-group text-right">
                <button class="btn btn-primary"  data-toggle="modal" data-target="#modalnewpermission" ><i class="fas fa-plus"></i> Jauna atļauja</button>
                <button class="btn btn-primary"  data-toggle="modal" data-target="#modalnewgroup" ><i class="fas fa-plus"></i> Jauna atļauju grupa</button>
            </div>
        </div>
        <div class="content">
            <div class="loading" v-if="loading == true">
                <i class="fas fa-spinner fa-spin"></i>
            </div>

                    <table class="permissionGroup table table-responsive-xl table-hover" >
                        <tbody v-for="(group,index) in permissionGroups" :key="group.id">
                            <tr v-if="index==0 || permissionGroups[index-1].id != group.name ">
                                <td colspan="100%" class="text-center font-weight-bold bg-light">
                                    <div class="groupWrapper">
                                        <div class="name">
                                            {{group.name}} ({{group.description}})
                                        </div>
                                        <div class="actions">
                                            <span class="edit" data-toggle="modal" :data-target="'#modal-'+group.id" @click="setGroupPopupDetails(group)"><i class="fas fa-edit"></i></span>
                                            <span @click="deletePermissionsGroup(group.id)"><i class="far fa-trash-alt"></i></span>
                                        </div>
                                    </div>


                                </td>

                                <div class="modal fade" tabindex="-1"  :id="'modal-'+group.id" :ref="'vuegroupmodal'+group.id">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header bg-primary text-white">
                                                <h5 class="modal-title">Atļauju grupas labošana</h5>
                                                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="form-group">
                                                            <label for="name">Nosaukums</label>
                                                            <input type="text" v-model="groupName" class="form-control" :class="{'is-invalid':errors && ( 'name' in errors)}">
                                                            <small class="text-danger" v-if="errors && errors.name">{{errors.name[0]}}</small>
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="description">Apraksts</label>
                                                            <input type="text" v-model="groupDescription" class="form-control" :class="{'is-invalid':errors && ( 'description' in errors)}">
                                                            <small class="text-danger" v-if="errors && errors.description">{{errors.description[0]}}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <input type="button" class="btn btn-primary" value="Saglabāt" @click="updatePermissionsGroup(group.id)" v-if="loading == false">
                                                <button type="button" class="btn btn-primary"  v-if="loading == true"><i class="fas fa-spinner fa-spin"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </tr>
                            <permission-component v-for="permission in group.permissions" :permission="permission" :groups="permissionGroups" :key="permission.id"></permission-component>
                        </tbody>
                        <tbody v-if="ungroupedPermissions.length>0">
                            <tr>
                                <td colspan="100%" class="text-center font-weight-bold bg-danger text-white">Negrupētās atļaujas</td>
                            </tr>
                            <permission-component v-for="permission in ungroupedPermissions" :permission="permission" :groups="permissionGroups" :key="permission.id"></permission-component>
                        </tbody>
                    </table>

        </div>
        <div class="modal fade" tabindex="-1"  id="modalnewgroup" ref="vuegroupmodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Jauna atļauja grupa</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="name">Nosaukums</label>
                                    <input type="text" v-model="newGroupName" class="form-control" :class="{'is-invalid':errors && ( 'name' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.name">{{errors.name[0]}}</small>
                                </div>
                                <div class="form-group">
                                    <label for="description">Apraksts</label>
                                    <input type="text" v-model="newGroupDescription" class="form-control" :class="{'is-invalid':errors && ( 'description' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.description">{{errors.description[0]}}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <input type="button" class="btn btn-primary" value="Pievienot" @click="newPermissionsGroup()" v-if="loading == false">
                        <button type="button" class="btn btn-primary"  v-if="loading == true"><i class="fas fa-spinner fa-spin"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" tabindex="-1"  id="modalnewpermission" ref="vuemodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Jauna atļauja</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="display_name">Nosaukums</label>
                                    <input type="text" v-model="display_name" class="form-control" :class="{'is-invalid':errors && ( 'display_name' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.display_name">{{errors.display_name[0]}}</small>
                                </div>
                                <div class="form-group">
                                    <label for="name">Programmatiskais nosaukums</label>
                                    <input type="text" v-model="name" class="form-control" :class="{'is-invalid':errors && ( 'name' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.name">{{errors.name[0]}}</small>
                                </div>
                                <div class="form-group">
                                    <label for="description">Apraksts</label>
                                    <input type="text" v-model="description" class="form-control" :class="{'is-invalid':errors && ( 'description' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.description">{{errors.description[0]}}</small>
                                </div>
                                <div class="form-group">
                                    <label for="group">Atļaujas grupa</label>
                                    <select v-model="permission_group_id" class="form-control" name="group">
                                        <option v-for="group in permissionGroups" :key="group.id" :value="group.id">{{group.name}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <input type="button" class="btn btn-primary" value="Pievienot" @click="newPermission()" v-if="loading == false">
                        <button type="button" class="btn btn-primary"  v-if="loading == true"><i class="fas fa-spinner fa-spin"></i></button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        data()
        {
            return {
                loading:true,
                name:"",
                display_name:"",
                description:"",
                permission_group_id:null,
                errors:null,
                permissions:[],
                permissionGroups:[],
                groupName:"",
                groupDescription:"",
                newGroupName:"",
                newGroupDescription:"",
                ungroupedPermissions:[]
            }
        },
        mounted()
        {
            var that = this;
            this.getPermissionsGroups();
             EventBus.$on('permission_deleted', () =>{
                this.getPermissionsGroups();
            });
             EventBus.$on('permission_created', () =>{
                this.getPermissionsGroups();
            });
             EventBus.$on('permission_updated', () =>{
                this.getPermissionsGroups();
            });
             EventBus.$on('permissions_group_deleted', () =>{
                this.getPermissionsGroups();
            });
             EventBus.$on('permissions_group_created', () =>{
                $(that.$refs.vuegroupmodal).modal('hide');
                this.getPermissionsGroups();
            });
             EventBus.$on('permissions_group_updated', () =>{
                this.getPermissionsGroups();
            });

        },
        methods: {
            setGroupPopupDetails(group)
            {
              this.groupName = group.name;
              this.groupDescription = group.description;
            },
            deletePermissionsGroup(id)
            {
                var that = this;
                this.$swal.fire({
                    title: 'Vai tiešām vēlaties dzēst atļauju grupu?',
                    text: "Visas atļaujām grupa tiks noņemta. Pašas atļaujas netiks dzēstas.",
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Jā',
                    cancelButtonText: 'Atcelt'
                }).then((result) => {
                    if(result.value)
                    {
                        axios.post('/dashboard/api/permissions-group/'+id+'/delete')
                            .then(response =>{
                                that.$toast.open({
                                    message: response.data.message,
                                    type: 'error',
                                });
                                 EventBus.$emit('permissions_group_deleted');
                            });
                    }
                })

            },
            updatePermissionsGroup(id)
            {
                var that = this;
                axios.post('/dashboard/api/permissions-group/'+id,{
                    name: this.groupName,
                    description: this.groupDescription
                }).then(response =>
                {
                    if(response.data.status == 'ok')
                    {
                        that.$toast.open({
                            message: response.data.message,
                        });
                        var modal = 'vuegroupmodal'+id;
                        $(that.$refs[modal]).modal('hide');
                         EventBus.$emit('permissions_group_updated');
                    }
                    that.errors = response.data.errors;

                });
            },
            getPermissionsGroups()
            {
                var that = this;
                axios.post('/dashboard/api/permissions-groups/get')
                    .then(response => {
                        that.permissionGroups = response.data.permissionGroups;
                        that.ungroupedPermissions = response.data.ungroupedPermissions;
                        that.loading = false;
                    });
            },
            newPermissionsGroup()
            {
                var that = this;
                that.loading = true;
                axios.post('/dashboard/api/permissions-groups',{
                    name: this.newGroupName,
                    description:this.newGroupDescription
                }).then(response => {
                     EventBus.$emit('permissions_group_created');
                    that.newGroupName="";
                    that.newGroupDescription="";
                    that.errors = response.data.errors;
                    that.loading = false;
                })
            },
            newPermission()
            {
                var that = this;
                that.loading = true;
                axios.post('/dashboard/api/permissions',{
                    name: this.name,
                    description:this.description,
                    permission_group_id:this.permission_group_id,
                    display_name:this.display_name
                }).then(response => {
                    if(response.data.status == 'ok') {
                         EventBus.$emit('permission_created');
                        that.$toast.open(response.data.message);
                        $(that.$refs.vuemodal).modal('hide');
                    }
                    that.errors = response.data.errors;
                    that.loading = false;
                })
            }
        }
    }
</script>

<style lang="scss">
    .groupWrapper{
        display:flex;
        .actions
        {
            min-width: 100px;
            margin-left:auto;
            span{
                padding:10px;
            }
        }
    }
</style>
